import { useParams } from 'react-router-dom'
import { useCallback, useEffect } from 'react'
import { useQuery } from 'react-query'
import { useStats } from '../ctx/stats'
import { useStatsTheme } from '../../theme/ctx'
import { useReaderSummary } from '../ctx/reader_summary'

export const useLoadStats = () => {
  const { id: paramId } = useParams()
  const [setStatsUserId, statsUserId, getStats, status, isSelfView, authUser] =
    useStats((s) => [
      s.setStatsUserId,
      s.statsUserId,
      s.getStats,
      s.status,
      s.isSelfView,
      s.authUser,
    ])
  const setTheme = useStatsTheme((s) => s.setTheme)
  const [setReaderSummary, generateSummary] = useReaderSummary((s) => [
    s.setReaderSummary,
    s.generateSummary,
  ])

  const getUserId = useCallback(() => {
    return statsUserId || paramId || authUser?.id || ''
  }, [paramId, statsUserId, authUser])

  const loadStatsUserId = useCallback(() => {
    if (!statsUserId) setStatsUserId(getUserId())
  }, [setStatsUserId, getUserId, statsUserId])

  useEffect(() => {
    loadStatsUserId()
  }, [loadStatsUserId])

  useQuery(
    ['user-stats', statsUserId],
    async () =>
      await getStats({
        status: status === 'idle' ? 'refreshing' : 'loading',
      }),
    {
      enabled: !!statsUserId && !!authUser,
      refetchOnWindowFocus: true,
      refetchOnMount: true,
      staleTime: 0,
      cacheTime: 0,
      onSuccess: async (stats) => {
        if (!stats) return

        const optIn = !!authUser?.stats_summary_opt_in

        setReaderSummary({
          stats,
          isSelfView,
          isUserOptedIn: optIn,
        })

        setTheme(stats.theme)

        if (isSelfView && optIn && !stats.summary?.length) {
          await generateSummary()
        }
      },
    }
  )
}
